module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAmElEQVQoU5XRvw4BQRzE8c89kleTeCMEBQnFlSpaHSWVUkIjIf5kZVc2cnF3v3bnO5mdKdDFCEctrsALDywxwBSXOo8E5ror5hiixL3KpArMdSeMY5J1TPd5rwNzk300CEl2bcBkEkrsNQXPmKEfS3z+A2+xnBBtgVDa937BMM0q/mWCUE7lJXAb6w87Huo2TK12sGkizjVvgDYrZiQQbF0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 1